import React, { PureComponent } from 'react'
import componentFader from 'aria-viewer/utils/componentFader'
import injectSheet from 'react-jss'
import { connect } from 'react-redux'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import waitForAction from 'aria-viewer/utils/waitForAction'
import { MEDIA_TYPES, SCREEN_SIZES } from 'aria-viewer/tour/constants'

const { LG_SCREEN } = SCREEN_SIZES.size_1350

const styleSheet = {
    container: {
        position: 'absolute',
        background: 'rgba(0, 0, 0, 0.7)',
        color: 'white',
        left: '50%',
        top: '50%',
        padding: ({ viewportWidth }) => (viewportWidth >= LG_SCREEN ? '10px' : '7px'),
        transform: 'translate(-50%, -50%)',
        zIndex: 10,
        fontSize: ({ viewportWidth }) => (viewportWidth >= LG_SCREEN ? '20pt' : '15pt'),
        fontWeight: 400,
        borderRadius: 6,
        minWidth: ({ viewportWidth }) => (viewportWidth >= LG_SCREEN ? '130px' : '110px'),
        textAlign: 'center',
    },
}

const StopTitle = componentFader(
    injectSheet(styleSheet)(({ classes, stopName, viewportWidth }) => (
        <div className={classes.container}>{stopName}</div>
    ))
)

StopTitle.displayName = 'StopTitle'

/**
 *  StopTitleWelcomeToast
 *  displays the title of the current stop
 *  for a few seconds in the center of
 *  the screen in a toast
 *  @platform Desktop
 */
class StopTitleWelcome extends PureComponent {
    constructor(props) {
        super(props)
        this.state = { isShown: false }
    }
    componentWillReceiveProps(nextProps) {
        // if the stop title changes, we can
        // assume that we've visited another stop
        // and show it (based on current mediaType)
        if (this.props.currentStop.title !== nextProps.currentStop.title) {
            const { isShown } = this.state
            const nextIsShown = [MEDIA_TYPES.photo].includes(nextProps.mainMediaType)

            if (isShown != nextIsShown) {
                this.setState({ isShown: nextIsShown })
            }

            // behavior to hide stop title if necessary in 3 seconds
            waitForAction({ time: 3000, checkCancelCondition: () => !this.state.isShown }).then(() => {
                this.setState({ isShown: false })
            })
        }
    }
    render() {
        return (
            <StopTitle
                viewportWidth={this.props.sizes.width}
                isShown={this.state.isShown}
                stopName={this.props.currentStop.title}
            />
        )
    }
}

export default connect(mapSelectorsToProps(['currentStop', 'mainMediaType']))(StopTitleWelcome)
